import { CITIES_SUCCESS } from '../constants'

const initialState = {
  cities: [],
  grouped: [],
  hydrated: false
}

const handlers = {
  [CITIES_SUCCESS]: (state, action) => {
    const cities = action.response

    return {
      ...state,
      cities
    }
  }
}

export default function reducer(state = initialState, action) {
  if (!state.hydrated) {
    state = {
      ...initialState,
      ...state,
      hydrated: true
    }
  }

  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}

export const selectCities = ({ cities }) => cities.cities
